module.exports = __webpack_public_path__ + "img/eaaci-activity.256bbd1a.svg";